//-- Copyright (c) 2021 TMT Insights Group, LLC
import React from 'react';
import styled from '@emotion/styled';
import { TimelineOppositeContent } from '@mui/lab';
import { Typography } from '@mui/material';
import { convertSecondsToDuration } from '../../_utils/date';
import DateTimeDisplay from './DateTimeDisplay';

type TimelineTimestampProps = {
  datetime: string;
};
const TimelineTimestamp = ({ datetime }: TimelineTimestampProps) => {
  const secondsAgo = +new Date() / 1000 - +new Date(datetime) / 1000;

  return (
    <OppositeContent sx={{ minWidth: 120, maxWidth: 120, display: { xs: 'none', sm: 'block' } }}>
      <DateTimeDisplay>{datetime}</DateTimeDisplay>
      <Typography variant="caption">{secondsAgo > 60 ? convertSecondsToDuration(secondsAgo) + ' ago' : 'Just now'}</Typography>
    </OppositeContent>
  );
};

export default TimelineTimestamp;

const OppositeContent = styled(TimelineOppositeContent)`
  & .MuiTypography-subtitle2 {
    font-size: 0.8rem;
    white-space: nowrap;
    margin-top: ${({ theme }) => theme.spacing(1)};
    opacity: 0.5;
  }

  & .MuiTypography-caption {
    font-size: 0.9rem;
    white-space: nowrap;
    margin-top: 0;
    line-height: 2;
    opacity: 0.9;
  }
`;
